module.exports = __webpack_public_path__ + "02_hair_black.629c8e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/02_hair_black.png
// module id = wycx
// module chunks = 0